import { Box } from '@base-app';
import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

export const cardGridStyles: CSS = {
  marginBottom: '$6',
  width: '100%',
};

export const StyledFormSectionContainer = styled(Box, {
  padding: '$8 $8 $2 $8',
});

export const StyledFormFieldsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  '@sm': {
    flexDirection: 'row',
  },
});

export const leftFormFieldStyles: CSS = {
  width: '100%',
  '@sm': {
    paddingRight: '$3',
    width: '50%',
  },
};

export const rightFormFieldStyles: CSS = {
  width: '100%',
  '@sm': {
    paddingLeft: '$3',
    width: '50%',
  },
};

export const consentLabelStyles: CSS = {
  fontSize: '$sm',
  color: '$charcoal500',
};

export const submitButtonStyles: CSS = {
  margin: 'auto',
  marginTop: '$4',
};

export const inputNumberStyles: CSS = {
  /* This styles are for hide up and down arrows for number type inputs */
  /* Chrome, Safari, Edge, Opera */
  'input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
  },
  /* Firefox */
  'input[type=number]': {
    '-moz-appearance': 'textfield',
  },
};
